"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var paymentsApi_1 = require("../../paymentsApi");
var Wallets = /** @class */ (function () {
    function Wallets(_a) {
        var paymentModule = _a.paymentModule, methodId = _a.methodId, orderId = _a.orderId, onMessage = _a.onMessage, walletPaymentInNewTab = _a.walletPaymentInNewTab, host = _a.host;
        var _this = this;
        this.setup = function () { return true; };
        this.remove = function () { return true; };
        this.render = function () { return Promise.resolve(true); };
        this.pay = function (method) { return __awaiter(_this, void 0, void 0, function () {
            var inNewTab, chargeRequest, chargeResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        inNewTab = this.props.walletPaymentInNewTab;
                        if (inNewTab) {
                            // It should be sync in case of blocking async windows by browser
                            // `chargeResponse` param we will get by .charge() calling after opening empty window
                            this.props.paymentModule.launchPaymentPopup(method, { chargeResponse: {} });
                        }
                        chargeRequest = {
                            orderId: this.props.orderId,
                            payment: {
                                details: {
                                    paymentMethod: this.props.methodId,
                                    // Always `1` for wallets
                                    installments: 1,
                                    creditCardToken: {
                                        // Always empty for wallets
                                        token: ''
                                    }
                                }
                            }
                        };
                        return [4 /*yield*/, paymentsApi_1.default.charge({ request: chargeRequest, host: this.props.host })];
                    case 1:
                        chargeResponse = _a.sent();
                        return [2 /*return*/, this.props.paymentModule.continuePayment(method, { chargeResponse: chargeResponse, inNewTab: inNewTab })];
                }
            });
        }); };
        this.validate = function (walletId) {
            if (_this.props.onMessage) {
                _this.props.onMessage(walletId, { type: 'VALIDATION', isValid: true });
            }
            return Promise.resolve({ isValid: true });
        };
        this.collapse = function (walletId) { return Promise.resolve({ method: walletId, type: 'COLLAPSE', status: 'collapsed' }); };
        this.expand = function (walletId) { return Promise.resolve({ method: walletId, type: 'EXPAND', status: 'expanded' }); };
        this.getMetadata = function () {
            return {
                popupSupported: true,
            };
        };
        this.props = {
            paymentModule: paymentModule,
            host: host,
            methodId: methodId,
            orderId: orderId,
            walletPaymentInNewTab: walletPaymentInNewTab,
            onMessage: onMessage,
        };
    }
    return Wallets;
}());
exports.default = Wallets;
//# sourceMappingURL=Wallets.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/cashier-payments-sdk/dist/src/modules/web/Wallets.js
// module id = 414
// module chunks = 0 1